import moment, { Moment } from "moment-timezone";
import BaseModel from "./BaseModel";
import SponsorModel from "./SponsorModel";

export default class SponsorshipModel extends BaseModel {
  maxStudentCount?: number;
  sponsor?: SponsorModel | null;
  startingDate?: Moment | null;
  constructor(arg: any) {
    super(arg);
    this.maxStudentCount = arg.max_student_count;
    this.sponsor = !!arg.sponsor
      ? SponsorModel.fromApiResponse(arg.sponsor)
      : null;
    this.startingDate = !!arg.starting_date
      ? moment(arg.starting_date, "YYYY-MM-DD")
      : null;
  }
}
